// Modules
import React from 'react';

import {
  DefaultTimeReportForm
} from 'components/models/time-report/forms/time-report-form';
import { SVGButton } from 'components/widgets/buttons';
import { alerts } from 'modules/alerts/actions';
import { roundToQuarter } from 'utils/app-utils';
import FormPopover from 'components/widgets/overlays/form';
import TicketLink from 'components/models/ticket/ticket-link';
import Timer from 'services/data/timer';

import * as actions from './actions';

// Component
class TimerTimeReportForm extends React.Component {
  constructor() {
    super();

    this.afterSaveTimeReport = this.afterSaveTimeReport.bind(this);
  }

  afterSaveTimeReport(timeReport) {
    const { timer } = this.props;
    this.popover.hide();

    alerts.success({
      title: 'Time report added!',
      subtitle: <TicketLink ticket={timer.ticket} linkSuffix="/time">View in ticket</TicketLink>
    });

    actions.update({ ...timer, timeReport: timeReport.id, status: 'Converted' });
  }

  render() {
    const { timer } = this.props;
    const roundedDuration = roundToQuarter(Timer.getDuration(timer).asMinutes() / 60);
    const duration = roundedDuration || 0.25;

    return (
      <FormPopover
        id={`timer-create-time-report-${timer.uuid}`}
        placement="top"
        className="popover-no-padding"
        target={<SVGButton title="Create Time Report" src="svg/time-report.svg" className="btn-primary rounded-circle p-2 mr-2" />}
        title="Create Time Report"
        ref={(el) => { this.popover = el; }}
      >
        <DefaultTimeReportForm
          cancel={this.cancel}
          afterSubmit={this.afterSaveTimeReport}
          ticket={timer.ticket}
          agreement={timer.ticket.agreement}
          initialValues={{
            duration,
            description: timer.description
          }}
          form={`timer-time-report-form-${timer.id}`}
        />
      </FormPopover>
    );
  }
}

// Exports
export default TimerTimeReportForm;



// WEBPACK FOOTER //
// ./app/modules/timers/timer-time-report-form.js